// Client site (sky99 codebase) ki themes — admin ke "Site Theme" page pe dikhti hain.
// 'default' = purani navy + gold. Baaki sab ek hi TULA111 jaisa layout ("skin") + apne rang
// (client: sky99/src/themes/palettes.scss, admin: src/index.css palettes). Keys teeno jagah same rakho:
// sky99/src/config.js THEMES, yahan, aur backend AppUrl.theme enum (sky99/docs/SITE_THEME_BACKEND.md).
// Preview images: public/theme-previews/<key>-home.jpg, <key>-login.jpg (client ke asli screenshots).
// `palette` admin panel ka apna rang bhi deta hai (App.jsx AntD tokens).
const previews = (k) => ({ home: `/theme-previews/${k}-home.jpg`, login: `/theme-previews/${k}-login.jpg` });

export const SITE_THEMES = {
  default: {
    label: 'Default',
    subtitle: 'Navy + Gold',
    description: 'Purani theme — gehra navy background, gold buttons / tabs, orange-blue odds.',
    swatches: ['#1b2a4a', '#2c3e64', '#f5b528', '#f5a935'],
    previews: previews('default'),
  },
  teal: {
    label: 'Teal',
    subtitle: '#264653 + #2A9D8F',
    description: 'Gehra teal header, teal tabs / market headings, halki cards, pink-blue odds.',
    swatches: ['#264653', '#2A9D8F', '#5fb5aa', '#e6f2f0'],
    palette: { dark: '#264653', dark2: '#1b343e', accent: '#2A9D8F', accentDark: '#23877b', accentSoft: '#5fb5aa' },
    previews: previews('teal'),
  },
  royal: {
    label: 'Royal Blue',
    subtitle: '#1d2b5e + #3b5bdb',
    description: 'Gehra navy-blue header, royal blue tabs / headings / buttons.',
    swatches: ['#1d2b5e', '#3b5bdb', '#8ea2f2', '#e8edfc'],
    palette: { dark: '#1d2b5e', dark2: '#142047', accent: '#3b5bdb', accentDark: '#2f49b5', accentSoft: '#8ea2f2' },
    previews: previews('royal'),
  },
  purple: {
    label: 'Purple',
    subtitle: '#3a2060 + #7c3aed',
    description: 'Gehra jamuni header, purple tabs / headings / buttons.',
    swatches: ['#3a2060', '#7c3aed', '#b49af5', '#f1eafd'],
    palette: { dark: '#3a2060', dark2: '#2a1647', accent: '#7c3aed', accentDark: '#6528d1', accentSoft: '#b49af5' },
    previews: previews('purple'),
  },
  crimson: {
    label: 'Crimson Red',
    subtitle: '#4a1520 + #d1344f',
    description: 'Gehra maroon header, laal tabs / headings / buttons.',
    swatches: ['#4a1520', '#d1344f', '#ef8a9b', '#fdebee'],
    palette: { dark: '#4a1520', dark2: '#360e17', accent: '#d1344f', accentDark: '#b02a42', accentSoft: '#ef8a9b' },
    previews: previews('crimson'),
  },
  emerald: {
    label: 'Emerald Green',
    subtitle: '#12402e + #18a058',
    description: 'Gehra hara header, emerald tabs / headings / buttons.',
    swatches: ['#12402e', '#18a058', '#6fcf9a', '#e6f6ee'],
    palette: { dark: '#12402e', dark2: '#0b2e20', accent: '#18a058', accentDark: '#12854a', accentSoft: '#6fcf9a' },
    previews: previews('emerald'),
  },
  midnight: {
    label: 'Midnight Orange',
    subtitle: '#1f2329 + #f08c00',
    description: 'Lagbhag kaala header, orange tabs / headings / buttons.',
    swatches: ['#1f2329', '#f08c00', '#ffbb5c', '#fff4e5'],
    palette: { dark: '#1f2329', dark2: '#15181d', accent: '#f08c00', accentDark: '#cc7700', accentSoft: '#ffbb5c' },
    previews: previews('midnight'),
  },
  // max365.pro (WBT99 jaisa) — client sky99 palettes.scss `theme-wbt`. Peele (#F5B870) highlights
  // sirf max365 brand pe (index.css html[data-brand="max365"]).
  wbt: {
    label: 'WBT Sky Blue',
    subtitle: '#5db5ee + #F5B870',
    description: 'Sky blue header (#5db5ee, max365 login jaisa), halka neela page, peele tabs / buttons / table headers.',
    swatches: ['#5db5ee', '#3a9ad9', '#F5B870', '#eaf4fd'],
    palette: { dark: '#5db5ee', dark2: '#4aa3dc', accent: '#3a9ad9', accentDark: '#2f6699', accentSoft: '#F5B870',
      tableHead: '#F5B870', tableHeadText: '#1f1f1f', tableHeadSort: '#f0a955' }, // client jaisa peela table header
    previews: previews('teal'),
  },
};

export const THEME_KEYS = Object.keys(SITE_THEMES);
